// Recognizer display names — used instead of technical model names
export const RECOGNIZER_LABELS = {
    gliner: "Dynamic Tagging",
    spacy: "Trained Tagging",
    "privacy-filter": "Privacy Filter",
    pattern: "Pattern (Regex)",
    llm: "LLM Tagging"
};

export const RECOGNIZER_COLORS = {
    gliner: { color: "#1677ff", bg: "#e6f4ff", border: "#91caff" },
    spacy:  { color: "#52c41a", bg: "#f6ffed", border: "#b7eb8f" },
    "privacy-filter": { color: "#722ed1", bg: "#f9f0ff", border: "#d3adf7" },
    pattern: { color: "#08979c", bg: "#e6fffb", border: "#87e8de" },
    llm: { color: "#d46b08", bg: "#fff7e6", border: "#ffd591" }
};

// Default GLiNER configuration
export const DEFAULT_DYNAMIC_TAGGING = {
    model: "urchade/gliner_multi_pii-v1",
    threshold: 0.6
};

// Workflow steps for the stepper component
// icon keys are resolved in MlTraining.js
export const WORKFLOW_STEPS = [
    { key: 0, title: "Tags", description: "Define entity types", icon: "tags" },
    { key: 1, title: "Model Training", description: "Prepare data & train", icon: "experiment" },
    { key: 2, title: "Configure", description: "Set up detection rules", icon: "setting" },
    { key: 3, title: "Profiles", description: "Per-class rule deltas", icon: "profile" },
    { key: 4, title: "Test Model", description: "Validate detection", icon: "bug" }
];
